module.exports = __webpack_public_path__ + "371bfe434a6a85760141a59465a1e4b8.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/Wolf.png
// module id = IEm7
// module chunks = 0